import { ControlledMaskInput } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { removeMaskSpaces } from '@sravni/cosago-react-library/lib/utils';

import { Masks } from 'constants/masks';

import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';

export const LastWorkExperienceStartMonth: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const validate = useValidateOnBlur(type, true);

  return (
    <div onBlur={validate}>
      <ControlledMaskInput
        {...props}
        name={type}
        mask={Masks.MONTH}
        transformOutput={removeMaskSpaces}
        inputMode="numeric"
      />
    </div>
  );
};
